import { render } from "./MovieGenre.vue?vue&type=template&id=1f5de8ea&scoped=true"
import script from "./MovieGenre.vue?vue&type=script&lang=js"
export * from "./MovieGenre.vue?vue&type=script&lang=js"

import "./MovieGenre.vue?vue&type=style&index=0&id=1f5de8ea&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5de8ea"]])

export default __exports__